<template>
  <div class="ucontainer">
    <h2 class="heading_fonts text-center gap-y-100-50">
      Types of Hiring Programs
    </h2>
    <div class="grid">
      <div class="">
        <div
          style="background: #003A76;
"
        >
          <h3
            class="text-center custom_dark_yellow manrope"
            style="margin-bottom:0;padding:10px;"
          >
            Bootcamp
          </h3>
        </div>
        <div style="background: #5D80BA;padding:10px 0; min-height:100%">
          <ul>
            <li>
              <p>
                Initial Assessment Test
              </p>
            </li>
            <li>
              <p>
                Pass the test and Enroll
              </p>
            </li>
            <li>
              <p>
                The actual bootcamp/course -Live classes, Video Recordings
              </p>
            </li>
            <li>
              <p>
                Multiple assessment tests during the bootcamp
              </p>
            </li>
            <li>
              <p>
                Ranking the learners. The mentor will assess this.
              </p>
            </li>
            <li>
              <p>
                Top 4-5 learners will get a chance to interview at the specified
                company.
              </p>
            </li>
            <li>
              <p>
                Hire them based on the final interview.
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="">
        <div style="background: #003A76;">
          <h3
            class="text-center manrope custom_dark_yellow manrope "
            style="margin-bottom:0; padding:10px"
          >
            Test Based Assessment
          </h3>
        </div>
        <div style="background: #5D80BA;padding:10px 0;min-height:100%">
          <ul>
            <li>
              <p>
                Assessment Test (Test is made by professionals) Candidates
              </p>
            </li>
            <li>
              <p>
                Assessment Test (Test is made by professionals)
              </p>
            </li>
            <li>
              <p>
                Candidates must pass the test by scoring 60% . i.e 6 out of 10
              </p>
            </li>
            <li>
              <p>
                Upskill collects the passing candidates resume and other details
              </p>
            </li>
            <li>
              <p>
                Upskill send top 5 candidate list to the company
              </p>
            </li>
            <li>
              <p>
                Shortlisted candidates gets the chance to go to the interview
                directly
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
ul li {
  padding-left: 30px;
  color: white;
}
ul li p {
  margin-bottom: 0px;
  font-size: 18px;
  font-family: 'Manrope';
}
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2%;
  color: #29292b;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 50px;
  padding-bottom: 100px;
}
@media (max-width: 767.98px) {
}
</style>
